'use client';

import React from 'react';
export var DropdownContext = /*#__PURE__*/React.createContext({
  values: [],
  items: [],
  open: false,
  selectedItems: [],
  setOpen: function setOpen() {},
  setValues: function setValues() {},
  setItems: function setItems() {}
});
export var useDropdownContext = function useDropdownContext() {
  var context = React.useContext(DropdownContext);
  if (!context) {
    throw new Error('Dropdown compound components cannot be rendered outside the Dropdown component');
  }
  return context;
};